import React, {useState} from 'react';

export default function CsfBrokerSearch(props) {

  /*
  * Method to build the right sort options depending on the list type
  * */
  const getSortOptions = (type) => {
    const sortData = {
      compliance: {
        'Member_LastName': window.Drupal.t('search.option.broker.name'),
        'Member_Number': window.Drupal.t('search.option.broker.numero'),
      },
      consent: {
        'Member_LastName': window.Drupal.t('search.option.broker.name'),
        'Member_Number': window.Drupal.t('search.option.broker.numero'),
        'company': window.Drupal.t('search.option.broker.branch'),
      },
    };
    return sortData[type];
  };

  /*
  * Method to build the right display options depending on the list type
  * */
  const getDisplayOptions = (type) => {
    const displayData = {
      compliance: {
        '': window.Drupal.t('broker.compliance.all'),
        'Oui': window.Drupal.t('broker.compliance.conform'),
        'Non': window.Drupal.t('broker.compliance.noConform')
      },
      consent: {
        '': window.Drupal.t('broker.consent.all'),
        '2': window.Drupal.t('broker.noConsent'),
        '1': window.Drupal.t('broker.consent'),
        '0': window.Drupal.t('broker.pendingConsent'),
        '3': window.Drupal.t('broker.account-not-activated')
      },
    };
    return displayData[type];
  };

  return (
    <div>
      <div className="mb-3">
        <form className="w-100" id="form-compliance-search">
          <div className="row">
            <div className="col-12 col-lg">
              <div className="js-form-item form-item js-form-type-textfield form-group">
                <label htmlFor="compliance-search">{window.Drupal.t('search.label')}</label>
                <input placeholder={props.searchPlaceholder} type="text"
                        id="compliance-search" name="compliance-search"
                        onChange={props.handleSearchInputChange} value={props.searchValue} size="30"
                        maxLength="128"
                        className="w-100 form-text"></input>
              </div>
            </div>

            <div className="col-12 col-lg">
              <div className="js-form-item form-item js-form-type-select form-item-sort-by js-form-item-sort-by form-group">
                <label htmlFor="compliance_sort_by">{window.Drupal.t('search.sortBy')}</label>
                <select value={props.sortValue} onChange={props.handleSortInputChange}
                        id="compliance_sort_by" name="compliance_sort_by" className="w-100 form-select form-text">
                  {Object.entries(getSortOptions((props.listType))).map(([key, value]) => (<option
                    key={key}
                    value={key}
                  >
                    {value}
                  </option>))}
                </select>
              </div>
            </div>

            <div className="col-12 col-lg">
              <div className="js-form-item form-item js-form-type-select form-group">
                <label htmlFor="compliance_display_by">{window.Drupal.t('search.display')}</label>
                <select value={props.displayValue} onChange={props.handleDisplayInputChange}
                        data-drupal-selector="compliance_display_by" id="compliance_display_by"
                        name="compliance_display_by"
                        className="w-100 form-select form-text">
                  {Object.entries(getDisplayOptions(props.listType)).map(([key, value]) => (
                    <option
                      key={key}
                      value={key}
                    >
                    {value}
                  </option>))}
                </select>
              </div>
            </div>

            <div className="col-auto mt-1 mt-lg-0 form-actions js-form-wrapper form-wrapper"
                  id="edit-actions">
              <input type="submit" id="submit-compliance" onClick={props.handleSubmitFilteringSearch}
                      value={window.Drupal.t('search.button')}
                      className="js-form-submit form-submit button btn-larger"></input>
            </div>

            <div className="col-auto mt-1 mt-lg-0 px-2 brokerSearchTotalColumn">
                {window.Drupal.t('broker.pagination.total.label')}
                {props.searchTotal}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
